export default __webpack_public_path__ + "static/media/landUseLaw.09bc7ddc.svg";